import { Component, Input } from '@angular/core';
export class CollapsibleComponent {
   title: string;
constructor(
  ) {
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'my-collapsible',
  template: "﻿<!--<button type=\"button\" class=\"btn btn-info\" data-toggle=\"collapse\" data-target=\"#demo\">{{title}}</button>--> <div class=\"collapser\" data-toggle=\"collapse\" data-target=\"#collapseTarget\">{{title}} <span class=\"caret\"></span> <div id=\"collapseTarget\" class=\"collapse\"> <ng-content></ng-content> </div></div>",
  styles: ["﻿// component styles are encapsulated and only applied to their components .home-text { color: #ff0000; } .buy-now-button { font-size: 0.8em; font-style: italic; background-color: bisque; color: black; font-weight: bold; } "]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'title': [{ type: Input },],
};
}

function CollapsibleComponent_tsickle_Closure_declarations() {
/** @type {?} */
CollapsibleComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CollapsibleComponent.ctorParameters;
/** @type {?} */
CollapsibleComponent.propDecorators;
/** @type {?} */
CollapsibleComponent.prototype.title;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
